const baseRoutes = [
  {
    path: '/tabs',
    component: () => import("@/_routes/tabs/Root"),
    redirect: '/tabs/security',
    children: [
      {
        path: 'security',
        component: () => import("@/_routes/tabs/Security")
      },
      {
        path: 'cameras',
        component: () => import("@/_routes/tabs/Cameras")
      },
      {
        path: 'activity',
        component: () => import("@/_routes/tabs/Activity")
      },
      {
        path: 'incidentReports',
        component: () => import("@/_routes/tabs/incidentReports/Root")
      },
      {
        path: '/tabs/incidentReports/:reportId',
        component: () => import("@/_routes/tabs/incidentReports/IncidentReport")
      },
      ...menuRoutes
    ],
  },
]

import menuRoutes from '@/_routes/tabs/menu/_router'

const routes = baseRoutes

export default routes
